import { appUserAccessPermissions } from 'global/auth/appUserAccessPermissions'
import { useContext } from 'react'
import { AppUsersContext } from '../AppUsersContext'
import { ParentContext } from '../ParentContext'
import { useAppUserAccess } from './useAppUserAccess'

export const useAppAccessPermissions = () => {

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { currentSettings_state, appUser_state, paps_state, page_state } = states

  const { aps_global, aps_viewItems, aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appUserCollection } = aps_appUserSettings ?? {}
  const { aps_page } = _.get(page_state, 'pageSettings', {});

  const appUsersContext = useContext(AppUsersContext)
  const { appUsers_state } = appUsersContext ?? {}
  const { eventAppUsers } = appUsers_state ?? {}

  const { appUser, appUsers } = appUser_state ?? {}
  const { pathViews } = paps_state ?? {}

  const appUserAccess = useAppUserAccess()

  const prmOthers = {
    paps_state,
    aps_global,
    aps_viewItems,
    aps_page,
    aps_appUserSettings,
    appUserAccess,
    pathViews,
  }

  return appUserAccessPermissions(
    {
      appUsers,
      appUser,
      appUserCollection,
      eventAppUsers,
      prmOthers,
    })

}
